import _ from 'lodash';
import { EnumUtil } from '@tencent/adp-fe-common';

/** 事件状态：1-未处理, 2-升级未处理, 3-已处理 */
export const EVENT_STATUS = EnumUtil.createEnumWithAlias({
  unhandled: [1, '未处理'],
  upgradedUnhandled: [2, '升级未处理'],
  handled: [3, '已处理'],
  overdue: [4, '已过期'],
});

/** 事件状态 Select 数据 */
export const EVENT_STATUS_OPTIONS = _.map(EVENT_STATUS, (value: number) => ({
  value,
  label: EVENT_STATUS.getDescByValue(value),
}));

/** 事件场景 */
export const EVENT_SCENE = {
  riskManage: '风控管理',
  saleManage: '销售管理',
  operationMode: '经营模式',
} as const;

/** 事件场景 Select 数据 */
export const EVENT_SCENE_OPTIONS = Object.values(EVENT_SCENE).map((v) => ({ value: v, label: v }));

/** 事件类型：1-红灯, 2-黄灯, 3-绿灯 */
export const EVENT_TYPE = EnumUtil.createEnumWithAlias({
  red: [1, '红灯'],
  yellow: [2, '黄灯'],
  green: [3, '绿灯'],
});

/** 事件类型 Select 数据 */
export const EVENT_TYPE_OPTIONS = _.map(EVENT_TYPE, (value: number) => ({
  value,
  label: EVENT_TYPE.getDescByValue(value),
}));

/** 事件名称 */
export const EVENT_NAME = {
  meteringPunishment: '计量处罚预警',
  leadDistribute: '平台线索分发',
  performanceForecast: '业绩预估上报',
} as const;

/** 事件名称 Select 数据 */
export const EVENT_NAME_OPTIONS = Object.values(EVENT_NAME).map((v) => ({ value: v, label: v }));

/** 扣罚金额承担方：1-服务商，2-客户，3-其他 */
export const PENALTY_BEARER = EnumUtil.createEnumWithAlias({
  agency: [1, '100%服务商自主承担'],
  client: [2, '100%服务商子账号或客户承担'],
  other: [3, '其他'],
});

/** 扣罚金额承担方 Select 数据 */
export const PENALTY_BEARER_OPTIONS = _.map(PENALTY_BEARER, (value: number) => ({
  value,
  label: PENALTY_BEARER.getDescByValue(value),
}));
